import { render, staticRenderFns } from "./EPGProvider.vue?vue&type=template&id=19668f9f&"
import script from "./EPGProvider.vue?vue&type=script&lang=js&"
export * from "./EPGProvider.vue?vue&type=script&lang=js&"
import style0 from "./EPGProvider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports